<template>
  <div class="content-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-12">
          <!-- Recent Order Table -->
          <div class="card card-table-border-none card-white" id="recent-orders">
            <div class="card-header justify-content-between">
              <h2>{{ $t("sidebar.mySales") }}</h2>
            </div>
            <div class="table-responsive-xs table-responsive-sm card-body card-white pt-0 pb-5">
              <table class="table card-table table-striped width-100">
                <thead>
                  <th class="d-md-table-cell text-center">
                    {{ $t("ecommerce.product.name") }}
                  </th>
                  <th class="d-md-table-cell d-none text-center">
                    {{ $t("ecommerce.orders") }}
                  </th>
                  <th class="d-md-table-cell d-none text-center">
                    {{ $t("ecommerce.product.totalPrice") }}
                  </th>
                  <th class="d-md-table-cell text-center">
                    {{ $t("main.action") }}
                  </th>
                </thead>
                <tbody>
                  <tr v-for="product in productsWithOrders" :key="product.id">
                    <td class="d-md-table-cell text-center">
                      <a class="text-dark" href=""> {{ product.name }}</a>
                    </td>
                    <!-- Price -->
                    <td class="d-md-table-cell d-none text-center">
                      {{ product.orders.length }}
                    </td>

                    <!-- Quantity -->
                    <td v-if="product.orders[0].offers" class="d-md-table-cell d-none text-center">
                      {{
                        product.orders[0].offers.price
                        | currency(" DA", 0, { symbolOnLeft: false })
                      }}
                    </td>
                    <td v-else-if="product.orders[0].bids" class="d-md-table-cell d-none text-center">
                      {{
                        product.orders[0].bids.price
                        | currency(" DA", 0, { symbolOnLeft: false })
                      }}
                    </td>

                    <!-- Payment type -->
                    <td class="d-md-table-cell text-center">
                      <a :href="downloadUrl +
                        'order/' +
                        product.orders[0].id +
                        '/print/' +
                        SALES_INVOICES
                        " target="_blank" rel="noopener noreferrer">
                        {{ $t("action.downloadInvoice") }}
                      </a>
                      <router-link :to="{
                        name: 'showInvoice',
                        params: {
                          orderId: product.orders[0].id,
                          type: SALES_INVOICES,
                        },
                      }">
                        {{ $t("sentence.seeMore") }}
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config.js";

export default {
  mounted() {
    this.getUserOrders();
  },
  data() {
    return {
      products: [],
      success: false,
      SALES_INVOICES: "SALES_INVOICES",
      downloadUrl: config.baseurl,
    };
  },
  methods: {
    getUserOrders() {
      var self=this;
      this.$store;
      this.$axios({
        url: "user/sales",
        method: "GET",
      })
        .then((response) => {
          self.products=response.data;
        })
        .catch(function (err) {
          console.log(err.response.data);
        });
    },
  },
  computed: {
    productsWithOrders() {
      return this.products.filter((i) => i.orders.length>0);
    },
  },
};
</script>
